<template>
  <header class="vertical center" v-if="isMobile && !isGameplay">
    <img class="logo" src="@/assets/show-logo-mobile.png" alt="MTV Siesta Key" />
    <div class="vertical-spacer"></div>
    <img class="title" src="@/assets/activity-title-mobile.png" alt="Siesta Sleuth" />
  </header>
  <header class="horizontal center" v-else v-bind:class="{gameplay: isGameplay}">
    <img class="logo" src="@/assets/show-logo.png" alt="MTV Siesta Key" />
    <div class="horizontal-spacer"></div>
    <img class="title" src="@/assets/activity-title.png" alt="Siesta Sleuth" />
  </header>
</template>

<script>
import { ActivitySize } from "@/store";

export default {
  props: {
    isGameplay: Boolean
  },
  computed: {
    isMobile() {
      return (
        this.$store.state.size === ActivitySize.MOBILE ||
        this.$store.state.size === ActivitySize.TINY
      );
    }
  }
};
</script>

<style lang="scss" scoped>
header {
  margin: rems(30px) 0;
}
.vertical-spacer {
  max-width: rems(450px);
  width: 100%;
}
img {
  max-width: 100%;
}
.horizontal .logo {
  width: rems(176px);
  height: rems(119px);
}
.horizontal .title {
  width: rems(529px);
  height: rems(40px);
}
.horizontal.gameplay .logo {
  width: rems(119px);
  height: rems(81px);
}
.horizontal.gameplay .title {
  width: rems(360px); //.68
  height: rems(27px);
}
.gameplay .horizontal-spacer {
  margin-left: rems(24px);
  margin-right: rems(24px);
  height: rems(100px);
}
//
.vertical .logo {
  width: rems(448px);
  height: rems(110px);
}
.vertical .title {
  width: rems(452px);
  height: rems(28px);
}
</style>
